import Portfolio from "../../../Assets/images/work/anand1.png";
import Portfolio2 from "../../../Assets/images/work/anand2.png";
import MithaiBasket from "../../../Assets/images/work/mithai1.png";
import Hirebird from "../../../Assets/images/work/hirebird.png";
import Covercrafter from "../../../Assets/images/work/covercrafter.png";

export const WorkData = [
    {
        id: 0,
        img: Portfolio,
        name: "Artistry Anand",
        link: "https://www.artistryanand.in",
    },
    {
        id: 1,
        img: Portfolio2,
        name: "Artistry Anand",
        link: "https://www.artistryanand.in/",
    },
    {
        id: 2,
        img: Hirebird,
        name: "Hire Bird",
        link: "",
    },
    {
        id: 3,
        img: Covercrafter,
        name: "Cover Crafter",
        link: "https://covercrafter-ch.netlify.app/",
    },
   
    {
        id: 4,
        img: MithaiBasket,
        name: "Mithai Basket",
        link: "https://mithaibasket.onrender.com/",
    },
    
]